module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "around"
  }, [_c('div', {
    staticStyle: {
      "height": "12rem"
    }
  }, [_c('swiper', {
    staticClass: "swiper-box",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.annexInfo), function(img, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "swiper-item"
    }, [_c('img', {
      attrs: {
        "src": img
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination swiper-pagination-btn",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "Property"
  }, [_c('div', {
    staticClass: "base-info"
  }, [_c('span', [_vm._v("均价：\n        "), _c('label', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.avgPrice + '元/平米'))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.buildingType))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.address))]), _vm._v(" "), _c('div', {
    staticClass: "nav",
    on: {
      "click": _vm.mapNav
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/nav.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "facility around"
  }, [_c('div', {
    staticClass: "facility-info"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.introduce)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6a04f3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/around.vue
// module id = 238
// module chunks = 1